import { Component, Input, OnInit } from '@angular/core';
import { CompanyDetailsComponent } from '../details/details.component';
import { LayoutService } from 'app/layout/layout.service';

@Component({
  selector: 'app-company-task-details',
  template: `<app-task-details (close)="onClose()"></app-task-details>`,
})
export class CompanyTaskDetailsComponent implements OnInit {
  constructor(private readonly layoutService: LayoutService) {}

  taskDetailConfig = {
    showAssignedTaskRole: false,
    showAttachements: false,
    showSubtasks: false,
    showActivities: false,
    redirectOnClose: false,
  };

  ngOnInit() {}

  onClose() {
    this.layoutService.emitCommon('crm-tasks', false);
  }
}
